// Must stay the first import: hands the CSP nonce to style-injecting libraries before they load.
import "./security/cspNonce";
import ReactDOM from "react-dom/client";
import App from "./App";

import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
